import { connect } from "react-redux";
import { ConnectOzonetelDTO, EdufinInitialStateDTO } from "../service/types";
import { RootState, TypedDispatch } from "../../../../redux/store";
import {
  deleteEdufin,
  downloadEdufin,
  getEdufinData,
  saveEdufinData,
} from "../service/EdufinSlice";
import DraftSavedEdufinBranchesList from "../components/EdufinDetails/DraftSavedEdufinBranchesList";
import EdufinDetails from "../components/EdufinDetails/EdufinDetails";

interface DispatchProps {
  DeleteEdufin(id: string): void;
  DownloadEdufin(data: any): void;
  GetEdufinData(data: any): void;
  SaveEdufinData(data: any): void;
}

const mapStateToProps = (state: RootState): EdufinInitialStateDTO => {
  return {
    deleteEdufinLoading: state.edufin.deleteEdufinLoading,
    deleteEdufinSuccess: state.edufin.deleteEdufinSuccess,
    deleteEdufinError: state.edufin.deleteEdufinError,
    downloadEdufinLoading: state.edufin.downloadEdufinLoading,
    downloadEdufinSuccess: state.edufin.downloadEdufinSuccess,
    downloadEdufinError: state.edufin.downloadEdufinError,
    edufinDataLoading: state.edufin.edufinDataLoading,
    edufinDataSuccess: state.edufin.edufinDataSuccess,
    edufinDataError: state.edufin.edufinDataError,
    edufinData: state.edufin.edufinData,
    saveEdufinLoading: state.edufin.saveEdufinLoading,
    saveEdufinSuccess: state.edufin.saveEdufinSuccess,
    saveEdufinError: state.edufin.saveEdufinError,
    saveEdufinData: state.edufin.saveEdufinData,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    DownloadEdufin: (data: any) => {
      dispatch(downloadEdufin(data));
    },
    DeleteEdufin: (id: string) => {
      dispatch(deleteEdufin(id));
    },
    GetEdufinData: (body: any) => {
      dispatch(getEdufinData(body));
    },
    SaveEdufinData: (body: any) => {
      dispatch(saveEdufinData(body));
    },
  };
};

export interface EdufinProps extends EdufinInitialStateDTO, DispatchProps {}
export const EdufinComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(DraftSavedEdufinBranchesList);
export const EdufinDetailsComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(EdufinDetails);
